export const composeFormData = (
  obj: Record<string, unknown>,
  paramKey = '',
  withParsedArrayValues?: boolean,
): FormData => {
  const formData = new FormData()

  // NOTE: Handle array input - append as single value and return early
  if (Array.isArray(obj)) {
    formData.append(paramKey, obj as unknown as Blob)
    return formData
  }

  // NOTE: Separate keys into files (Blobs) and regular values
  const filesKeys = Object.keys(obj).filter(
    (key) => (Array.isArray(obj[key]) && obj[key][0] instanceof Blob) || obj[key] instanceof Blob,
  )
  const valuesKeys = Object.keys(obj).filter((key) => !filesKeys.includes(key))

  // NOTE: Process regular values (non-file data)
  valuesKeys.forEach((key) => {
    const value = obj[key]

    if (value === undefined) return
    if (Array.isArray(value)) {
      if (withParsedArrayValues) {
        // Append each array item separately
        value.forEach((item) => formData.append(key, item))
      } else {
        // Stringify the entire array
        formData.append(key, JSON.stringify(value))
      }
    } else {
      // Append primitive values directly (the browser coerces non-string, non-Blob values to a string)
      formData.append(key, value as string | Blob)
    }
  })

  // NOTE: Process file data (Blobs/Files)
  filesKeys.forEach((key) => {
    const value = obj[key]

    if (Array.isArray(value)) {
      // Append multiple files with same key
      value.forEach((file) => formData.append(key, file))
    } else if (value instanceof Blob) {
      // Append single file with fallback filename
      const fileName = (value as File).name || 'image.png'
      formData.append(key, value, fileName)
    }
  })

  return formData
}
